import { fetchTaxonomy } from "../services";
import { StoreApi } from "../types";

export const getCommunitiesTaxonomy = () => async ({ setState }: StoreApi) => {
    const terms = await fetchTaxonomy("communities");
    setState({ taxCommunities: terms });
};

export const getConditionsTaxonomy = () => async ({ setState }: StoreApi) => {
    const terms = await fetchTaxonomy("conditions-needs");
    setState({ taxConditionsNeeds: terms });
};

export const getGendersTaxonomy = () => async ({ setState }: StoreApi) => {
    const terms = await fetchTaxonomy("genders");
    setState({ taxGenders: terms });
};

export const getTaxonomyData = () => async ({ dispatch }: StoreApi) => {
    await Promise.all([
        dispatch(getCommunitiesTaxonomy()),
        dispatch(getConditionsTaxonomy()),
        dispatch(getGendersTaxonomy()),
    ]);
};
